<template>
  <div class="heatday--wrapper">
    <div class="heatday--wrapper--box">
      <div
        :class="{ 'heatday--shadow': !!theme }"
        :style="shadowStyles"
      />
      <div
        :class="['heatday--content', { active: !!theme }]"
        :style="heatDayStyles"
      />
      <div
        :class="['heatday--day', { active: !!theme }]"
        :style="{
          color: heatDayColor,
        }"
      >
        <slot />
      </div>
    </div>
  </div>
</template>
<script>
import { computed } from 'vue';

export default {
  props: {
    theme: {
      type: String,
      default: '',
    },
    radius: {
      type: Number,
      default: 100,
    },
    opacity: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const minRadius = 45;
    const minOpacity = 10;

    /* When opacity is below this number, we will apply the light class so the inner text
    gets displayed darker than the whole content. */
    const minLightColorOpacity = 0.35;

    const calculateRelative = (min, value) => ((((100 - min) * value) / 100) + min) / 100;

    const heatDayStyles = computed(() => ({
      transform: `scale(${calculateRelative(minRadius, props.radius)})`,
      background: `${props.theme}${Math.floor(calculateRelative(minOpacity, props.opacity) * 255).toString(16).padStart(2, '0')}`,
    }));

    const heatDayColor = computed(() => (calculateRelative(minOpacity, props.opacity) > minLightColorOpacity ? '#ffffff' : (props.theme || '#767676')));

    const shadowStyles = computed(() => ({
      transform: `scale(${calculateRelative(minRadius, props.radius)})`,
    }));

    return {
      heatDayStyles,
      shadowStyles,
      heatDayColor,
    };
  },
};
</script>
<style scoped>
.heatday--wrapper {
  @apply w-full mb-3;
  max-width: 3.5rem;

  &--box {
    @apply w-full h-0 relative;
    padding-bottom: 100%;
    &:hover {
      .heatday--shadow {
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
      }
    }

    .heatday--content {
      @apply rounded-full w-full h-full absolute top-0 left-0;
      &.active {
        @apply cursor-pointer;
      }
    }

    .heatday--shadow {
      @apply rounded-full w-full h-full absolute top-0 left-0 z-0;
    }

    .heatday--day {
      @apply absolute text-sm top-50 left-50 transform -translate-x-2/4 -translate-y-2/4 cursor-default;
      &.active {
        @apply cursor-pointer;
      }
    }
  }
}
</style>
